import { CultureInfo } from '../culture-info.model';
import { CultureInfoTa } from './ta';

/**
 * @ignore
 */
export const CultureInfoTaIN: CultureInfo = {
  name: 'ta-IN',
  displayName: 'Tamil (India)',
  iso3LanguageCode: 'tam',
  iso2LanguageCode: 'ta',
  ietfLanguageTag: 'ta-IN',
  parent: CultureInfoTa
};
